import clsx from 'clsx';
import React, { ReactElement } from 'react';

import styles from './Table.module.scss';

export interface TableProps {
  className?: string;
  withBodyRowHover?: boolean;
  TableHeaderContent: ReactElement | ReactElement[];
  TableBodyContent: ReactElement | ReactElement[];
  isHeaderSticky?: boolean;
}

export const Table = ({
  withBodyRowHover = true,
  TableHeaderContent,
  TableBodyContent,
  className,
  isHeaderSticky = false,
}: TableProps) => {
  return (
    <table
      className={clsx(
        styles.table,
        withBodyRowHover && styles.withBodyRowHover,
        isHeaderSticky && styles.isHeaderSticky,
        className
      )}
    >
      <thead>{TableHeaderContent}</thead>
      <tbody>{TableBodyContent}</tbody>
    </table>
  );
};
